export interface ITicketResponse {
  projectId: string;
  id: string;
  ticketIds: string[];
}

export interface IAssignTicketsToComponentResponse {
  componentId: string;
  ticketIds: string[];
  userId: string;
}

export interface IAssignTicketsToSprintResponse {
  targetId: string;
  targetType: AssignTicketsTargetTypeEnum;
  ticketIds: string[];
  userId: string;
}

export interface IAssignTicketsToEpicResponse {
  epicId: string;
  ticketIds: string[];
}

export interface IAssignTicketsToStoryResponse {
  storyId: string;
  ticketIds: string[];
}

export enum AssignTicketsTargetTypeEnum {
  SPRINT = "SPRINT",
  BACKLOG = "BACKLOG",
  NEW_SPRINT = "NEW_SPRINT",
}

export enum TicketTagsActionsEnum {
  ADD = "add",
  REMOVE = "remove",
  Replace = "replace",
}

export interface ITicketTagsResponse {
  tags: string[];
  projectId: string;
  tagActions: TicketTagsActionsEnum;
  ticketIds: string[];
}

export interface TicketFieldsState {
  isTicketUpdating: boolean;
  isBulkExporting: boolean;
}
